import React, { useEffect, useRef } from 'react';
import { FaRegSadTear, FaArrowLeft } from 'react-icons/fa';
import './NotAssigned.css';

const NotAssigned = () => {
  const containerRef = useRef(null);
  const iconRef = useRef(null);
  const titleRef = useRef(null);
  const messageRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    // Add animation class after a short delay to trigger the entrance animations
    const timer = setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.classList.add('animate-in');
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleGoBack = () => {
    // Add exit animations before going back
    if (containerRef.current) {
      containerRef.current.classList.add('animate-out');

      // Wait for animation to complete before going back
      setTimeout(() => {
        window.history.back();
      }, 600);
    } else {
      window.history.back();
    }
  };

  return (
    <div className="not-assigned-container" ref={containerRef}>
      <div className="background-animation">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="hexagon-grid"></div>
      </div>

      <div className="content-wrapper">
        <div className="icon-wrapper" ref={iconRef}>
          <FaRegSadTear className="not-assigned-icon" />
          <div className="tear-drop tear-1"></div>
          <div className="tear-drop tear-2"></div>
          <div className="icon-shadow"></div>
        </div>

        <h1 className="not-assigned-title" ref={titleRef}>Access Restricted</h1>
        <p className="not-assigned-message" ref={messageRef}>
          This page is not assigned to your account. Please contact your administrator if you believe this is an error.
        </p>

        <button
          className="not-assigned-button"
          onClick={handleGoBack}
          ref={buttonRef}
        >
          <FaArrowLeft className="button-icon" />
          Go Back
        </button>
      </div>
    </div>
  );
};

export default NotAssigned;